// document.addEventListener('DOMContentLoaded', function () {
//     // Select all div elements with class 'buy-buttons'
//     const buyButtons = document.querySelectorAll('div.buy-buttons');
    
//     // Select all elements whose ID contains 'quotify_button'
//     const quotifyElements = document.querySelectorAll('[id*="quotify_button"]');
  
//     // Create the wrapper div for all the elements
//     const wrapper = document.createElement('div');
//     wrapper.classList.add('quote-cart-wrapper'); // You can customize this class name
  
//     // Loop through each element and insert the wrapper in place
//     [...quotifyElements, ...buyButtons].forEach(function (element) {
//       // Get the parent of the current element
//       const parent = element.parentNode;
  
//       // Insert the wrapper before the element in the parent node
//       parent.insertBefore(wrapper, element);
  
//       // Append the current element to the wrapper
//       wrapper.appendChild(element);
//     });
//   });

//   document.addEventListener('DOMContentLoaded', function() {
//     // Log to check if the DOM is loaded
//     console.log('DOM fully loaded and parsed');
  
//     // Get the variant-selects, product-form__quantity, and add_to_compare elements
//     var variantSelects = document.querySelector('.variant-selects'); // Adjust the selector if necessary
//     var quantityForm = document.querySelector('.product-form__quantity');
//     var addToCompare = document.querySelector('.shopify-block');
  
//     // Log the elements to make sure we're selecting the right ones
//     console.log('variantSelects:', variantSelects);
//     console.log('quantityForm:', quantityForm);
//     console.log('addToCompare:', addToCompare);
  
//     var containsWord = addToCompare && addToCompare.id && addToCompare.id.includes('comparable_products');
//     console.log('Contains "comparable_products" in ID:', containsWord);
  
//     // Create a wrapper div for the elements
//     var wrapper = document.createElement('div');
//     wrapper.classList.add('product-options-wrapper');
//     console.log('Wrapper created:', wrapper);

//     // Add the available elements to the wrapper
//     if (variantSelects) {
//         wrapper.appendChild(variantSelects);
//         console.log('variantSelects appended to wrapper');
//     }

//     if (quantityForm) {
//         wrapper.appendChild(quantityForm);
//         console.log('quantityForm appended to wrapper');
//     }

//     if (containsWord && addToCompare) {
//         wrapper.appendChild(addToCompare);
//         console.log('addToCompare appended to wrapper');
//     }
  
//     // Find the parent element where these elements exist (e.g., .product-form)
//     var productForm = document.querySelector('.product-form');
//     console.log('productForm found:', productForm);
  
//     if (productForm) {
//         // Insert the wrapper into the product-form
//         productForm.appendChild(wrapper);
//         console.log('Wrapper appended to productForm:', productForm);
//     } else {
//         console.log('productForm not found!');
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    // Log to check if the DOM is loaded
    console.log('DOM fully loaded and parsed');
  
    // Get the variant-selects, product-form__quantity, and add_to_compare elements
    var variantSelects = document.querySelector('.variant-selects'); // Adjust the selector if necessary
    var quantityForm = document.querySelector('.product-form__quantity');
    var addToCompare = document.querySelector('.shopify-block');
  
    // Log the elements to make sure we're selecting the right ones
    console.log('variantSelects:', variantSelects);
    console.log('quantityForm:', quantityForm);
    console.log('addToCompare:', addToCompare);
  
    var containsWord = addToCompare && addToCompare.id && addToCompare.id.includes('comparable_products_add_to_compare');
    console.log('Contains "comparable_products" in ID:', containsWord);
  
    // Create a wrapper div for the elements
    var wrapper = document.createElement('div');
    wrapper.classList.add('product-options-wrapper');
    console.log('Wrapper created:', wrapper);

    // Add the available elements to the wrapper
    if (variantSelects) {
        wrapper.appendChild(variantSelects);
        console.log('variantSelects appended to wrapper');
    }

    if (quantityForm) {
        wrapper.appendChild(quantityForm);
        console.log('quantityForm appended to wrapper');
    }

    if (containsWord && addToCompare) {
        wrapper.appendChild(addToCompare);
        console.log('addToCompare appended to wrapper');
    }
  
    // Find the parent element where these elements exist (e.g., .product-form)
    var productForm = document.querySelector('.product-form');
    console.log('productForm found:', productForm);
  
    if (productForm) {
        // Insert the wrapper into the product-form
        productForm.appendChild(wrapper);
        console.log('Wrapper appended to productForm:', productForm);
    } else {
        console.log('productForm not found!');
    }

    // Move quotify elements beside product-form__buttons
    const quotifyElements = document.querySelectorAll('[id*="quotify_button"]');
    const productFormButtons = document.querySelector('.product-form__buttons');
    
    if (quotifyElements.length && productFormButtons) {
        quotifyElements.forEach(function(element) {
            productFormButtons.appendChild(element);  // Append each quotify button beside the product-form__buttons
            console.log('quotify element moved beside product-form__buttons');
        });
    } else {
        console.log('No quotify elements found or product-form__buttons not found');
    }
});

/*
document.addEventListener('DOMContentLoaded', function() {
    // Get all the 'details' elements within .product__accordion
    const accordionDetails = document.querySelectorAll('.product__accordion details');

    accordionDetails.forEach(function(detail) {
        const accordionContent = detail.querySelector('.accordion__content');
        const accordionParent = detail.closest('.product__accordion');
                    // Check if the accordion content has any content
        if (accordionContent && accordionContent.innerHTML.trim() === "") {
            // If no content, add the 'hide' class to the parent
            accordionParent.classList.add('hide');
        }
        // Add a click event listener to each details element
        detail.addEventListener('click', function() {
            // Get the accordion content
            accordionContent.classList.toggle('hide');
        });
    });
});
*/
document.addEventListener("DOMContentLoaded", function () {
    const fields = document.querySelectorAll('.product-tabs .metafield-multi_line_text_field');

    fields.forEach(field => {
      let content = field.innerHTML;

      // 1. Replace **bold text** with <strong>bold text</strong>
      content = content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

      // 2. Remove leading dash and space after line breaks or line start
      content = content.replace(/(<br>\s*|^)-\s*/g, '$1');

      // Apply the cleaned and formatted content
      field.innerHTML = content;
    });
});





 
  